export const managerStatementsHeaders = [
	{
		settings: true,
		text: "Month",
		value: "month",
		func: true,
		valueFilter: 'filter_month',
		model: { value: 'list' },
		sortable: true,

	},
	{
		settings: true,
		text: "Generated date",
		value: "created_date",
		func: true,
		valueFilter: 'filter_created_date',
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Generated by",
		value: "created_by",
		func: true,
		valueFilter: 'filter_created_by',
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Department",
		value: "department",
		func: true,
		valueFilter: 'filter_department',
		model: { value: 'list' },
		sortable: true,
	},
	// {
	// 	settings: true,
	// 	text: "Employee",
	// 	value: "dispatcher",
	// 	valueFilter: 'filter_dispatcher',
	// 	func: false,
	// 	model: { value: 'list' },
	// 	sortable: true,
	// },
	{
		settings: true,
		text: "Salary",
		value: "salary",
		func: true,
		valueFilter: 'filter_salary',
		model: { value: 'number' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Bonus/Charge",
		value: "bonus",
		func: true,
		valueFilter: 'filter_bonus',
		model: { value: 'number' },
		sortable: true
	},
	{
		settings: true,
		text: "Description",
		value: "description",
		func: true,
		valueFilter: 'filter_description',
		model: { value: 'note' },
		sortable: true,
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		sortable: true,
		func: true,
		valueFilter: 'filter_total',
		model: { value: 'number' }
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 10 ] },
				value: 'view',
				text: 'View manager statement',
				icon: { value: 'icon_view', w: 18, h: 14 },
			},
			{
				perm: { or: [ 11 ] },
				value: 'delete',
				text: 'Delete manager statement',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const managerStatementsHeadersUser = [
	{
		settings: true,
		text: "Month",
		value: "month",
		func: true,
		valueFilter: 'filter_month',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Generated date",
		value: "created_date",
		func: true,
		valueFilter: 'filter_created_date',
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Generated by",
		value: "created_by",
		func: true,
		valueFilter: 'filter_created_by',
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Department",
		value: "department",
		func: true,
		valueFilter: 'filter_department',
		model: { value: 'list' },
		sortable: true,
	},
	// {
	// 	settings: true,
	// 	text: "Employee",
	// 	value: "dispatcher",
	// 	valueFilter: 'filter_dispatcher',
	// 	func: true,
	// 	model: { value: 'list' },
	// 	sortable: true,
	// },

	{
		settings: true,
		text: "Salary",
		value: "salary",
		func: true,
		valueFilter: 'filter_salary',
		model: { value: 'number' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Base rate",
		value: "base_rate",
		func: true,
		valueFilter: 'filter_base_rate',
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
	},
	{
		settings: true,
		text: "Bonus/Charge",
		value: "bonus",
		func: true,
		valueFilter: 'filter_bonus',
		model: { value: 'number' },
		sortable: true
	},
	{
		settings: true,
		text: "Description",
		value: "description",
		func: true,
		valueFilter: 'filter_description',
		model: { value: 'note' },
		sortable: true,
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		sortable: true,
		func: true,
		valueFilter: 'filter_total',
		model: { value: 'number' }
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 10 ] },
				value: 'view',
				text: 'View manager statement',
				icon: { value: 'icon_view', w: 18, h: 14 },
			},
			{
				perm: { or: [ 11 ] },
				value: 'delete',
				text: 'Delete manager statement',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
